import Settings from '~/services/settings'

type GoogleOAuthCallback = (response: google.accounts.id.CredentialResponse) => void

export class GoogleOauthService {
	static init(callback: GoogleOAuthCallback) {
		if (!google?.accounts) return
		google.accounts.id.initialize({
			client_id: Settings.googleOAuthId(),
			callback,
		})
	}

	static renderButton(parentDiv: HTMLDivElement) {
		if (!google?.accounts) return
		google.accounts.id.renderButton(parentDiv, { type: 'standard' })
	}
}
